"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.contain = exports.overlapping = exports.overlappingOrTouching = exports.rangesToRangesDates = void 0;
var stringToDate = function (s) { return new Date(s); };
var rangeStringToDate = function (range) {
    var rangeDate = {
        start: typeof range.start === 'string' ? stringToDate(range.start) : range.start,
        end: typeof range.end === 'string' ? stringToDate(range.end) : range.end,
    };
    return rangeDate;
};
exports.rangesToRangesDates = function (list) {
    return list.map(function (range) { return (__assign(__assign({}, range), { range: rangeStringToDate(range.range) })); });
};
exports.overlappingOrTouching = function (range1, range2) {
    var endIsAfterOrEqual = range2.end.getTime() >= range1.start.getTime();
    var startIsBeforeOrEqual = range2.start.getTime() <= range1.end.getTime();
    return endIsAfterOrEqual && startIsBeforeOrEqual;
};
exports.overlapping = function (range1, range2) {
    var endIsAfter = range2.end.getTime() > range1.start.getTime();
    var startIsBefore = range2.start.getTime() < range1.end.getTime();
    return endIsAfter && startIsBefore;
};
exports.contain = function (range1, range2) {
    var endIsAfter = range1.end.getTime() >= range2.end.getTime();
    var startIsBefore = range1.start.getTime() <= range2.start.getTime();
    return endIsAfter && startIsBefore;
};
